
























import CommonBase from "../CommonBase";
import {Component, Inject, Prop, Watch} from "vue-property-decorator";
import Api from "./Api";
import {InvalidPhoneNumber, PhoneNumber} from "../../modules/models";
import TopHdr from "./TopHdr.vue";
import {phoneCheckedLocation, phoneCheck, PhoneCheckReply, signupLocation} from "@/modules/LoginFlow";
import Phoneinput from "@/components/phoneinput/Phoneinput.vue";
import rd from "@/modules/vRoutedefs";
import AppRedirector from "@/components/shared/AppRedirector.vue";
import {ignoreRedundantNavErr} from "@/router";

@Component({
    components: {
        "at-top-hdr": TopHdr,
        "at-phone-input": Phoneinput,
        "at-appredirector": AppRedirector,
    }
})
export default class MissingPhoneInp extends CommonBase {
    @Inject()
    api!: Api;
    @Prop({default: null})
    phone!: string | null;
    @Prop({default: false})
    signup!: boolean;
    @Prop({default: ""})
    redir!: string;
    @Prop({default: false})
    accountInit!: boolean;

    phonenum: PhoneNumber | null = null;

    get phoneInvalidMsgs(): string[] {
        if(this.resp && this.resp.phoneInvalidMsg) {
            return [this.resp.phoneInvalidMsg];
        }
        return [];
    }
    get apiErrorMsg(): string | null {
        return this.resp && this.resp.errorMsg || null;
    }

    working = false;

    resp: PhoneCheckReply | null = null;

    // Sends phone number to server to check what next step should be.
    // Possible replies:
    // 1:   Phone has received a pending confirm code that is not expired (within 1 hour).
    //      Inform user that he should check his SMS inbox and use the code if he finds one.
    //      Offer option "input code" that will do the same normal login.
    //      Offer option "cannot find code" that will redirect to same page as if no pending code is found
    //
    // 2:   Phone has active login code attached to a user, with password updated within last 5 days, and has
    //      no expired pending confirm codes registered later.
    //      Inform user that he should check his SMS inbox and use the code if he finds one.
    //      Offer option "input code" that will do the same normal login.
    //      Offer option "cannot find code" that will do renewLogin send.
    //
    // 3:   Phone has active login code older than 5 days, or a expired pending code newer than last confirmed.
    //      Inform user that the system can send a new code.
    //      Offer option "send new code" that will do renewLogin send.
    //
    // 4:   Phone is not registered (no replies).
    //      Offer option "register HSE card" to register new user with qr code card read.
    //      Offer option "register unverified user"
    async checkNextStep() {
        this.working = true;
        try {
            this.resp = await phoneCheck(this.phonenum, this.api);

            if(!this.resp.phoneInvalidMsg && this.phonenum != null) {
                if (this.signup && this.resp.confirmedCreated == "" && this.resp.pendingCreated == "") {
                    // Go directly to signup page
                    ignoreRedundantNavErr(this.$router.push(signupLocation(this.phonenum, this.redir)));

                } else {
                    if (this.signup && (this.resp.pendingCreated != "" || this.resp.confirmedCreated != "")) {
                        this.emitSnack(`Mobilnummer allerede registrert på bruker`);
                    }
                    ignoreRedundantNavErr(this.$router.push(phoneCheckedLocation(this.phonenum, this.resp.pendingCreated, this.resp.confirmedCreated, this.redir)));
                }
            }
        } catch (err) {
            if(err instanceof InvalidPhoneNumber) {
                this.resp = {phoneInvalidMsg: `Ugyldig mobilnummer`};
            }
        } finally {
            this.working = false;
        }
    }

    @Watch("phone", {immediate: true})
    onPhoneChanged() {
        this.phonenum = this.phone && PhoneNumber.fromString(this.phone) || null;
    }

    get abortTo() {
        return this.accountInit ? rd.public.signup.path : rd.public.path;
    }
}
